import { FC } from "preact/compat";
import { StyledTextProps } from "./interfaces";

const StyledText: FC<StyledTextProps> = ({
    "text-color": textColor,
    "font-style": fontStyle,
    "font-weight": fontWeight,
    content,
}) => (
    <span
        style={{
            ...(fontWeight && { fontWeight }),
            ...(fontStyle && { fontStyle }),
            ...(textColor && { color: textColor }),
        }}
    >
        {content}
    </span>
);

export default StyledText;
